module.exports = __webpack_public_path__ + "img/Banner-02.bb575bb2.png";